import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { prettyFloatMoney } from '@/helpers/utils';
import { MyLink } from '@/components/MyLink';
import { getTariffPlanTermsLink } from '@/helpers/loanTerms';
import { EMPTY_DASH } from '@scramble/utils';
import s from './index.module.scss'

export const LoanDetails = ({ loans }) => {
  const { t } = useTranslation();
  if (!loans) return null;

  return (
    <div className={s.wrapper}>
      <h2 className="f-22 f-500">{t('loans:loan_details.details')}</h2>

      <div className={s.table}>
        {loans[0].fees.success_fee ? (
          <div className={classnames(s.thead, 'success_fee')}>
            <div className={s.thead_col}>{t('loans:loan_details.loan_amount')}</div>
            <div className={s.thead_col}>{t('loans:loan_details.success_fee')}</div>
            <div className={s.thead_col}>{t('loans:loan_details.outstanding')}</div>
            <div className={s.thead_col}>{t('loans:loan_details.interest_rate')}</div>
            <div className={s.thead_col}>{t('loans:loan_details.loan_group')}</div>
          </div>
        ) : (
          <div className={classnames(s.thead, 'six_fee')}>
            <div className={s.thead_col}>{t('loans:loan_details.loan_amount')}</div>
            <div className={s.thead_col}>{t('loans:loan_details.outstanding')}</div>
            <div className={s.thead_col}>{t('loans:loan_details.loan_term')}</div>
            <div className={s.thead_col}>{t('loans:loan_details.loan_group')}</div>
          </div>
        )}

        {loans[0].fees.success_fee ? (
          <div className={s.tbody}>
            {loans.map((loan, idx) => (
              <div className={classnames(s.tbody_row, 'success_fee')} key={idx}>
                <div className={s.tbody_col}>{prettyFloatMoney(loan.total_amount)}</div>
                <div className={s.tbody_col}>{prettyFloatMoney(loan.fees.success_fee)}</div>
                <div className={s.tbody_col}>{prettyFloatMoney(loan.outstanding)}</div>
                <div className={s.tbody_col}>{`${Number(loan.interest_rate)}%`}</div>
                <div className={s.tbody_col}>{loan.risk_group.title}</div>
              </div>
            ))}
          </div>
        ) : (
          <div className={s.tbody}>
            {loans.map((loan, idx) => (
              <div className={classnames(s.tbody_row, 'six_fee')} key={idx}>
                <div className={s.tbody_col}>{prettyFloatMoney(loan.total_amount)}</div>
                <div className={s.tbody_col}>{prettyFloatMoney(loan.outstanding)}</div>
                <div className={s.tbody_col}>{loan.loan_term || EMPTY_DASH}</div>
                <div className={s.tbody_col}>
                  <MyLink href={getTariffPlanTermsLink(loan.tariff_plan)} underline>
                    {loan.risk_group.title}
                  </MyLink>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
